if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton?.querySelector('span');

        if (
          this.submitButton &&
          document.querySelector('cart-drawer')
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add(
          'loading'
        );

        const loadingSpinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (loadingSpinner) {
          loadingSpinner.classList.remove(
            'hidden'
          );
        }
const formData =
  new FormData(this.form);

const processQuickAddModal =
  this.closest('quick-add-modal');

const processOfferSuffix =
  document.body.dataset.templateSuffix;

const showProcessOffer =
  document.body.dataset.templateName === 'collection' &&
  ['biere', 'vin', 'spirit'].includes(processOfferSuffix);

const mainVariantId =
  formData.get('id');

const mainQuantity =
  Number(
    formData.get('quantity') || 1
  );
        /*
         * PRODUIT PRINCIPAL
         */
        const mainItem = {
          id: Number(mainVariantId),
          quantity: mainQuantity
        };

        /*
         * PROPRIÉTÉS DE LIGNE
         */
        const lineItemProperties = {};

        formData.forEach(
          (value, key) => {
            const propertyMatch =
              key.match(
                /^properties\[(.+)\]$/
              );

            if (
              propertyMatch &&
              value !== ''
            ) {
              lineItemProperties[
                propertyMatch[1]
              ] = value;
            }
          }
        );

        if (
          Object.keys(
            lineItemProperties
          ).length
        ) {
          mainItem.properties =
            lineItemProperties;
        }

        /*
         * SELLING PLAN
         */
        const sellingPlan =
          formData.get('selling_plan');

        if (sellingPlan) {
          mainItem.selling_plan =
            Number(sellingPlan);
        }

        /*
         * ADD-ON
         * Vinification / brassage / spiritueux
         */
        const productSection =
          this.closest('section') ||
          document;

        const selectedAddon =
          productSection.querySelector(
            '[data-process-addon] ' +
            '.process-addon__checkbox:checked' +
            '[data-addon-variant]'
          );

        const items = [
          mainItem
        ];

        if (selectedAddon) {
          items.push({
            id: Number(
              selectedAddon.dataset
                .addonVariant
            ),
            quantity: 1
          });
        }

        /*
         * SECTIONS DU PANIER EDGE
         */
        const sectionIds =
          this.cart
            ? this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.section || section.id
                )
            : [];

        const requestBody = {
          items
        };

        if (sectionIds.length) {
          requestBody.sections =
            sectionIds;

          requestBody.sections_url =
            window.location.pathname;

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        const config = {
          method: 'POST',

          headers: {
            Accept:
              'application/json',

            'Content-Type':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'
          },

          body:
            JSON.stringify(
              requestBody
            )
        };

        try {
          /*
           * AJOUT AU PANIER
           */
          const addResponse =
            await fetch(
              `${routes.cart_add_url}`,
              config
            );

          const response =
            await addResponse.json();

          /*
           * ERREUR SHOPIFY
           */
          if (
            !addResponse.ok ||
            response.status
          ) {
            publish(
              PUB_SUB_EVENTS.cartError,
              {
                source:
                  'product-form',

                productVariantId:
                  mainVariantId,

                errors:
                  response.errors ||
                  response.description,

                message:
                  response.message
              }
            );

            this.handleErrorMessage(
              response.description ||
              response.message
            );

            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );

            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                'true'
              );

              const firstSpan =
                this.submitButton.querySelector(
                  'span'
                );

              if (firstSpan) {
                firstSpan.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );
            }

            this.error = true;
            return;
          }

          /*
           * SI PAS DE DRAWER / NOTIFICATION
           */
          if (!this.cart) {
            window.location =
              window.routes.cart_url;

            return;
          }

          /*
           * IDENTIFIER LE PRODUIT PRINCIPAL
           * DANS LA RÉPONSE MULTI-ITEMS
           */
          const addedItems =
            Array.isArray(
              response.items
            )
              ? response.items
              : [response];

          const mainAddedItem =
            addedItems.find(
              (item) =>
                String(
                  item.variant_id ||
                  item.id
                ) ===
                String(
                  mainVariantId
                )
            ) ||
            addedItems[0];

          /*
           * ==================================================
           * RAFRAÎCHISSEMENT COMPLET DU PANIER EDGE
           * ==================================================
           */

          let freshSections =
            response.sections || {};

          let fullCartData = {};

          try {
            /*
             * Récupérer le vrai panier
             * après l'ajout pour avoir les prix à jour.
             */
            const cartResponse =
              await fetch(
                '/cart.js',
                {
                  method: 'GET',
                  headers: {
                    Accept: 'application/json'
                  },
                  cache: 'no-store'
                }
              );

            fullCartData =
              await cartResponse.json();

            // SÉCURITÉ ENLEVÉE ICI : 
            // On ne fait plus de 2ème requête de sections qui écrasait les données à jour
            
          } catch (refreshError) {
            console.error(
              'Erreur rafraîchissement panier Edge :',
              refreshError
            );
          }

          /*
           * FORMAT ATTENDU PAR EDGE
           */
          const updatedCartData = {
            ...fullCartData,

            id:
              mainAddedItem?.id ||
              Number(
                mainVariantId
              ),

            key:
              mainAddedItem?.key ||
              response.key,

            sections:
              freshSections
          };

          this.error = false;

          /*
           * NOTIFICATION PRIVATE RESERVE
           */
          if (
            this.dataset
              .privateReserve ===
            'true'
          ) {
            this.showPrivateReserveNotification();
          }

          /*
           * QUICK VIEW EDGE
           */
          const quickAddModal =
            this.closest(
              'quick-add-modal'
            );

          const quickViewModal =
            document.getElementById(
              'product-quick-view'
            );

          if (quickViewModal) {
            quickViewModal.classList.remove(
              'quick-view-loaded'
            );

            document.body.classList.remove(
              'quickview-open'
            );
          }

          /*
 * RENDRE LE PANIER
 * SANS RELOAD DE PAGE
 */
if (quickAddModal) {
  document.body.addEventListener(
    'modalClosed',
    () => {
      setTimeout(() => {
        this.cart.renderContents(updatedCartData);

        if (showProcessOffer) {
          this.showProcessOfferPopup(processOfferSuffix);
        }
      }, 0);
    },
    {
      once: true
    }
  );

  quickAddModal.hide(true);
} else {
  this.cart.renderContents(updatedCartData);

  if (showProcessOffer) {
    this.showProcessOfferPopup(processOfferSuffix);
  }
}

          /*
           * INFORMER LE RESTE DU THÈME
           */
          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                'product-form',

              productVariantId:
                mainVariantId,

              cartData:
                updatedCartData
            }
          );
        } catch (error) {
          console.error(
            'Erreur ajout au panier :',
            error
          );
        } finally {
          /*
           * FIN DU LOADING
           */
          this.submitButton.classList.remove(
            'loading'
          );

          if (
            this.cart &&
            this.cart.classList.contains(
              'is-empty'
            )
          ) {
            this.cart.classList.remove(
              'is-empty'
            );
          }

          if (!this.error) {
            this.submitButton.removeAttribute(
              'aria-disabled'
            );
          }

          if (loadingSpinner) {
            loadingSpinner.classList.add(
              'hidden'
            );
          }
        }
      }
showProcessOfferPopup(templateSuffix) {
  const offers = {
    vin: {
      variantId: 52292750573861,
      label: 'Ajouter le processus de vinification',
      price: '60 $'
    },
    biere: {
      variantId: 52292675240229,
      label: 'Ajouter le processus de brassage',
      price: '45 $'
    },
    spirit: {
      variantId: 52820876722469,
      label: 'Ajouter le processus de brassage',
      price: '40 $'
    }
  };

  const offer = offers[templateSuffix];

  if (!offer) return;

  if (!document.getElementById('process-addon-popup-style')) {
    const style = document.createElement('style');
    style.id = 'process-addon-popup-style';
    style.textContent = `
      .process-addon-popup {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: grid;
        place-items: center;
        padding: 20px;
        background: rgba(0, 0, 0, .5);
      }

      .process-addon-popup__box {
        width: min(100%, 500px);
        padding: 28px;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 15px 50px rgba(0, 0, 0, .25);
      }

      .process-addon-popup__box h2 {
        margin: 0 0 18px;
        font-size: 22px;
      }

      .process-addon-popup__choice {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 18px;
        border: 1px solid #d7d7d7;
        border-radius: 10px;
        cursor: pointer;
      }

      .process-addon-popup__choice:has(input:checked) {
        border-color: #ccb683;
        background: rgba(204, 182, 131, .12);
        box-shadow: 0 0 0 1px #ccb683;
      }

      .process-addon-popup__choice input {
        width: 20px;
        height: 20px;
        accent-color: #ccb683;
      }

      .process-addon-popup__actions {
        display: flex;
        gap: 10px;
        margin-top: 20px;
      }

      .process-addon-popup__actions button {
        min-height: 44px;
        padding: 0 16px;
        border-radius: 6px;
        cursor: pointer;
      }

      .process-addon-popup__add {
        border: 1px solid #ccb683;
        background: #ccb683;
        color: #fff;
      }

      .process-addon-popup__add:disabled {
        opacity: .5;
        cursor: not-allowed;
      }

      .process-addon-popup__skip {
        border: 1px solid #d7d7d7;
        background: #fff;
      }

      .process-addon-popup__error {
        margin-top: 12px;
        color: #b00020;
      }
    `;
    document.head.appendChild(style);
  }

  const popup = document.createElement('div');
  popup.className = 'process-addon-popup';
  popup.innerHTML = `
    <div
      class="process-addon-popup__box"
      role="dialog"
      aria-modal="true"
      aria-labelledby="process-addon-popup-title"
    >
      <h2 id="process-addon-popup-title">On le fait pour vous!</h2>

      <label class="process-addon-popup__choice">
        <input type="checkbox">
        <span>
          ${offer.label} — <strong>${offer.price}</strong>
        </span>
      </label>

      <p class="process-addon-popup__error" hidden></p>

      <div class="process-addon-popup__actions">
        <button class="process-addon-popup__add" type="button" disabled>
          Ajouter au panier
        </button>
        <button class="process-addon-popup__skip" type="button">
          Non merci
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(popup);

  const checkbox = popup.querySelector('input[type="checkbox"]');
  const addButton = popup.querySelector('.process-addon-popup__add');
  const skipButton = popup.querySelector('.process-addon-popup__skip');
  const errorMessage = popup.querySelector('.process-addon-popup__error');

  checkbox.addEventListener('change', () => {
    addButton.disabled = !checkbox.checked;
  });

  skipButton.addEventListener('click', () => popup.remove());

  addButton.addEventListener('click', async () => {
    addButton.disabled = true;
    addButton.textContent = 'Ajout en cours…';
    errorMessage.hidden = true;

    try {
      const cartElement =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      const sectionIds =
        cartElement &&
        typeof cartElement.getSectionsToRender === 'function'
          ? cartElement
              .getSectionsToRender()
              .map((section) => section.section || section.id)
          : [];

      const requestBody = {
        items: [
          {
            id: Number(offer.variantId),
            quantity: 1
          }
        ]
      };

      if (sectionIds.length) {
        requestBody.sections = sectionIds;
        requestBody.sections_url = window.location.pathname;
      }

      const root = window.Shopify.routes.root;

      const addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });

      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(
          addData.description ||
          addData.message ||
          'Le complément n’a pas pu être ajouté.'
        );
      }

      const cartResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      const cartData = await cartResponse.json();
      const addedItem = Array.isArray(addData.items)
        ? addData.items[0]
        : addData;

      popup.remove();

      if (cartElement && typeof cartElement.renderContents === 'function') {
        cartElement.renderContents({
          ...cartData,
          id: addedItem.id,
          key: addedItem.key,
          sections: addData.sections || {}
        });
      }
    } catch (error) {
      errorMessage.textContent =
        error.message || 'Une erreur est survenue.';
      errorMessage.hidden = false;
      addButton.disabled = false;
      addButton.textContent = 'Ajouter au panier';
    }
  });
}
      /*
       * ==================================================
       * NOTIFICATION PRIVATE RESERVE
       * ==================================================
       */
      showPrivateReserveNotification() {
        let notification =
          document.getElementById(
            'private-reserve-notification'
          );

        if (!notification) {
          notification =
            document.createElement(
              'div'
            );

          notification.id =
            'private-reserve-notification';

          notification.setAttribute(
            'role',
            'status'
          );

          notification.setAttribute(
            'aria-live',
            'polite'
          );

          notification.innerHTML = `
            <button
              type="button"
              class="private-reserve-notification__close"
              aria-label="Fermer la notification"
            >
              ×
            </button>

            <div
              class="private-reserve-notification__icon"
            >
              ✓
            </div>

            <div
              class="private-reserve-notification__content"
            >
              <strong>
                Étiquettes standards incluses
              </strong>

              <p>
                Votre vin Private Reserve comprend déjà
                les étiquettes de base. Vous pourrez quand
                même choisir un style différent à la
                prochaine étape.
              </p>
            </div>
          `;

          document.body.appendChild(
            notification
          );

          const closeButton =
            notification.querySelector(
              '.private-reserve-notification__close'
            );

          if (closeButton) {
            closeButton.addEventListener(
              'click',
              () => {
                notification.classList.remove(
                  'is-visible'
                );
              }
            );
          }
        }

        window.clearTimeout(
          window
            .privateReserveNotificationTimeout
        );

        notification.classList.remove(
          'is-visible'
        );

        requestAnimationFrame(
          () => {
            notification.classList.add(
              'is-visible'
            );
          }
        );

        window
          .privateReserveNotificationTimeout =
          window.setTimeout(
            () => {
              notification.classList.remove(
                'is-visible'
              );
            },
            8500
          );
      }

      /*
       * ==================================================
       * ERREURS PRODUIT
       * ==================================================
       */
      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      /*
       * ==================================================
       * BOUTON AJOUT AU PANIER
       * ==================================================
       */
      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) {
          return;
        }

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              this.submitButton.hasAttribute(
                'data-preorder'
              )
                ? window
                    .variantStrings
                    .preOrder
                : window
                    .variantStrings
                    .addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}